import { JsonProperty, Serializable } from 'ts-jackson'

@Serializable()
export class Branch {
  @JsonProperty('id') id!: number
  @JsonProperty('code') code: string = ''
  @JsonProperty('slug') slug: string = ''
  @JsonProperty('name') name: string = ''
  @JsonProperty('addressLine') addressLine: string = ''
  @JsonProperty('provinceId') provinceId!: number
  @JsonProperty('provinceName') provinceName: string | null = null
  @JsonProperty('districtId') districtId!: number
  @JsonProperty('districtName') districtName: string | null = null
  @JsonProperty('subDistrictId') subDistrictId!: number
  @JsonProperty('subDistrictName') subDistrictName: string | null = null
  @JsonProperty('zipCode') zipCode!: number
  @JsonProperty('mobilePhone') mobilePhone: string | null = null
  @JsonProperty('officePhone') officePhone: string | null = null
  @JsonProperty('faxNumber') faxNumber: string | null = null
  @JsonProperty('email') email: string | null = null
  @JsonProperty('mapUrl') mapUrl: string | null = null
  @JsonProperty('isActive') isActive: boolean = true
  @JsonProperty('activeMembers') activeMembers: number = 0
  @JsonProperty('staffCount') staffCount: number = 0
}

export interface CreateBranchPayload {
  code: string
  name: string
  mobilePhone: string
  officePhone?: string
  faxNumber?: string
  email?: string
  addressLine: string
  provinceId: number
  districtId: number
  subDistrictId: number
  zipCode: number
  mapUrl?: string
}

export type UpdateBranchPayload = Partial<CreateBranchPayload>

export interface BranchListQuery {
  page?: number
  pageSize?: number
  query?: string
}

export interface BranchListResult {
  data: Branch[]
  pagination: { total: number; page: number; pageSize: number }
}

/**
 * Who this branch's receipts are issued by: the saved values, or — for a field
 * never saved — what the receipt prints today, so the edit form opens
 * pre-filled. While `isEnabled` is off, receipts print the club and branch
 * details instead, whatever is saved here.
 */
@Serializable()
export class BranchReceiptSettings {
  @JsonProperty('branchId') branchId!: number
  @JsonProperty('isEnabled') isEnabled: boolean = false
  @JsonProperty('issuerName') issuerName: string = ''
  @JsonProperty('taxId') taxId: string = ''
  @JsonProperty('isHeadOffice') isHeadOffice: boolean = false
  @JsonProperty('rdBranchNo') rdBranchNo: string = ''
  @JsonProperty('branchName') branchName: string = ''
  @JsonProperty('addressLine') addressLine: string = ''
  @JsonProperty('provinceId') provinceId: number | null = null
  @JsonProperty('provinceName') provinceName: string = ''
  @JsonProperty('districtId') districtId: number | null = null
  @JsonProperty('districtName') districtName: string = ''
  @JsonProperty('subDistrictId') subDistrictId: number | null = null
  @JsonProperty('subDistrictName') subDistrictName: string = ''
  @JsonProperty('zipCode') zipCode: number | null = null
  @JsonProperty('phone') phone: string = ''
}

export type UpdateBranchReceiptSettingsPayload =
  | { isEnabled: false }
  | {
      isEnabled: true
      issuerName: string
      taxId: string
      isHeadOffice: boolean
      rdBranchNo?: string
      branchName?: string
      addressLine: string
      provinceId: number
      districtId: number
      subDistrictId: number
      zipCode: number
      phone: string
    }
